/**
 * 政令市
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/admin-types'
import {ADMIN_ORDINANCE_CITY_RESET_CONDITION, ADMIN_ORDINANCE_CITY_RESET_PAGINATION} from "../../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/masters/ordinance_cities`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
    },
  }
}

const ordinance_city = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 政令市一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param page
     * @param format
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { page, format }) {
      let api_path
      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      const params = {
        page: page
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format !== 'csv') {
            let content = data.content
            commit(types.ADMIN_ORDINANCE_CITY, { content })
            resolve(data.content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    // saveCondition ({ commit, state }, {}) {
    //   const params = {}
    //   commit(types.ADMIN_ORDINANCE_CITY_CONDITION, { params })
    // },
    resetState ({ commit }) {
      commit(types.ADMIN_ORDINANCE_CITY_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_ORDINANCE_CITY_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_ORDINANCE_CITY_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_ORDINANCE_CITY_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_ORDINANCE_CITY] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_ORDINANCE_CITY_CONDITION] (state, { params }) {
    }
  },

}

export default ordinance_city


